import { customFetch } from "@/client/custom-fetch";

import { TInsuranceCompanies } from "./insurance-companies.type";

const API_BASE = "/insurance-companies";

export const getAllInsuranceCompanies = async (): Promise<
  TInsuranceCompanies[]
> => {
  return customFetch<TInsuranceCompanies[]>(`${API_BASE}`);
};

export const getInsuranceCompanyById = async (
  id: string
): Promise<TInsuranceCompanies> => {
  return customFetch<TInsuranceCompanies>(`${API_BASE}/${id}`);
};

export const createInsuranceCompany = async (
  insuranceCompany: TInsuranceCompanies
) => {
  return customFetch<TInsuranceCompanies>(`${API_BASE}`, {
    method: "POST",
    body: JSON.stringify(insuranceCompany),
  });
};

export const deleteInsuranceCompany = async (id: string): Promise<void> => {
  return customFetch<void>(`${API_BASE}/${id}`, {
    method: "DELETE",
  });
};

export const updateInsuranceCompany = async (
  id: string,
  insuranceCompany: TInsuranceCompanies
) => {
  return customFetch<TInsuranceCompanies>(`${API_BASE}/${id}`, {
    method: "PATCH",
    body: JSON.stringify(insuranceCompany),
  });
};
